import * as React from "react";
import { LiveOutright, MiniOutright, AggregateCard, RenderPreliveOutright } from "../../../components";
import * as MiniCardTypes from "../../../components/MiniEventCardTypes";
import * as CardTypes from "../../../components/EventCardTypes";
export class RenderCard extends React.PureComponent {
    getCardType() {
        const ComponentTypeMap = {
            AggregateCard,
            CardTypes,
            MiniCardTypes,
            MiniOutright,
            LiveOutright,
            PreLiveOutright: RenderPreliveOutright
        };
        return this.props.event.cardType
            ? ComponentTypeMap[this.props.event.componentType][this.props.event.cardType]
            : ComponentTypeMap[this.props.event.componentType];
    }
    render() {
        const CardTypeComp = this.getCardType();
        return React.createElement(CardTypeComp, Object.assign({}, this.props));
    }
}
//# sourceMappingURL=RenderCard.js.map